type CsvField = string | null | undefined;

function escapeField(value: CsvField): string {
    if (value == null) return '';
    return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/**
 * RFC 4180 CSV: comma-delimited, fields quoted only when needed, rows joined
 * by `\n` with no trailing newline. Does not escape spreadsheet formulas.
 */
export function toCsv(header: string[], rows: CsvField[][]): string {
    return [header, ...rows].map((row) => row.map(escapeField).join(',')).join('\n');
}
